export default class ImplementationManager {
    constructor(api) {
        this.api = api;
    }

    getImplementations = (query, filter, licenses) =>
        this.api.getImplementations(query, filter, licenses);

    getImplementationDetail = () => this.api.getImplementationDetail();

    createFavorite = (idImpl) => this.api.createFavorite(idImpl);

    removeFavorite = (idImpl) => this.api.removeFavorite(idImpl);

    getFavorites = () => this.api.getFavorites();

    getLicenses = () => this.api.getLicenses();
}
